/* unplugin-vue-components disabled */import script from "./ImagesWall.vue?vue&type=script&setup=true&lang=js"
export * from "./ImagesWall.vue?vue&type=script&setup=true&lang=js"

import "./ImagesWall.vue?vue&type=style&index=0&id=7c64c60d&lang=stylus"

const __exports__ = script;

export default __exports__